export default {"src":"/_next/static/media/checkmark.025cd4e6.svg","height":25,"width":27,"blurWidth":0,"blurHeight":0};